import React from "react";
import ServiceItemCard from "./ServiceItemCard";

interface ServiceItemGridProps {
  items: any[];
  title?: string;
  handleItemClick: (id: number) => void;
  businessPage: (bizCode: string) => void;
  handleMapModal: (lat: any, lng: any, address: string) => void;
  bookingFormRef: React.RefObject<any>;
}

const ServiceItemGrid: React.FC<ServiceItemGridProps> = ({
  items,
  title = "Items",
  handleItemClick,
  businessPage,
  handleMapModal,
  bookingFormRef,
}) => {
  return (
    <div className="col-12">
      {items && items.length > 0 ? (
        <div className="row">
          {items.map((item) => (
            <ServiceItemCard
              key={item.id}
              item={item}
              handleItemClick={handleItemClick}
              businessPage={businessPage}
              handleMapModal={handleMapModal}
              onBook={(item, mode) => bookingFormRef.current?.open(item, mode)}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-5">
            <p className="text-muted">No {title.toLowerCase()} available in this selection.</p>
        </div>
      )}
    </div>
  );
};

export default ServiceItemGrid;